import styled from 'styled-components/macro';
import images from '~/constants/images';

export const Wrapper = styled.div`
  min-height: 100%;
  background-color: yellow;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.white};

  &:before {
    content: ' ';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    min-height: 100vh;
    opacity: 0.3;
    background-image: url(${images.beat});
    background-repeat: no-repeat;
    background-position: center;
  }

  & > * {
    position: relative;
  }
`;
